export enum BaseRoutes {
  V1 = "/api/v1",
  V2 = "/api/v2",
  AdminPanel = "/api/admin"
}
